import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const MenuItem = (props) => {
        const [selected, setSelected] = useState(false);
        const location = useLocation();

        useEffect(() => {
                if (`/${location.pathname.split('/').slice(-1)[0]}` === props.item.route) {
                        setSelected(true);
                } else {
                        setSelected(false);
                }
        }, [location.pathname, props.item.route]);

        return (
                <Link
                        className={`menu-item ${selected ? "menu-item-selected" : ""}`}
                        to={`${props.section.route}${props.item.route}`}
                >
                        <img
                                className="menu-icon"
                                src={`../icons/${props.item.icon}-${selected ? "white" : "blue"}.svg`}
                        />
                        <span>{props.item.name}</span>
                </Link>
        );
}

export default MenuItem;